import Vue from 'vue'
import PopupVue from './popup.vue'
import merge from 'element-ui/lib/utils/merge'
import {isVNode} from 'element-ui/lib/utils/vdom'
import { PopupManager } from 'element-ui/lib/utils/popup'

const defaults = {
  title: null,
  type: '',
  width: '500px',
  iconClass: '',
  showClose: true,
  modalFade: true,
  lockScroll: true,
  closeOnClickModal: true,
  closeOnPressEscape: true,
  closeOnHashChange: true,
  confirmButtonText: '',
  cancelButtonText: '',
  beforeClose: null,
  center: false,
  roundButton: false,
  distinguishCancelAndClose: false
}

const PopupVueConstructor = Vue.extend(PopupVue)

let currentMsg, instance
let msgQueue = []

const defaultCallback = action => {
  if (currentMsg) {
    let callback = currentMsg.callback
    if (typeof callback === 'function') {
      callback(instance.value, action)
    }
    if (currentMsg.resolve) {
      if (action === 'confirm') {
        currentMsg.resolve({value: instance.value, action})
      } else if (currentMsg.reject && (action === 'cancel' || action === 'close')) {
        currentMsg.reject(action)
      }
    }
  }
}

const initInstance = () => {
  instance = new PopupVueConstructor({
    el: document.createElement('div')
  })
  instance.callback = defaultCallback
}

const showNextMsg = () => {
  if (!instance) {
    initInstance()
  }
  instance.action = ''

  if (!instance.visible || instance.closeTimer) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift()

      let options = currentMsg.options
      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }
      if (options.callback === undefined) {
        instance.callback = defaultCallback
      }

      let oldCb = instance.callback
      instance.callback = (action, instance) => {
        oldCb(action, instance)
        showNextMsg()
      }
      if (isVNode(instance.message)) {
        instance.$slots.default = [instance.message]
        instance.message = null
      } else {
        delete instance.$slots.default
      }
      instance.$el.style.zIndex = PopupManager.nextZIndex()
      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.visible = true
      })
    }
  }
}

const Popup = function (options, callback) {
  if (Vue.prototype.$isServer) return
  if (typeof options === 'string' || isVNode(options)) {
    options = {
      message: options
    }
  } else if (options.callback && !callback) {
    callback = options.callback
  }

  if (typeof Promise !== 'undefined') {
    return new Promise((resolve, reject) => { // eslint-disable-line
      msgQueue.push({
        options: merge({}, defaults, Popup.defaults, options),
        callback: callback,
        resolve: resolve,
        reject: reject
      })

      showNextMsg()
    })
  } else {
    msgQueue.push({
      options: merge({}, defaults, Popup.defaults, options),
      callback: callback
    })

    showNextMsg()
  }
}

Popup.calculation = (options) => {
  return Popup(merge({
    title: '计算面板',
    message: '',
    component: 'Calculation'
  }, options))
}

Popup.close = () => {
  instance.doClose()
  instance.visible = false
  msgQueue = []
  currentMsg = null
}

export default {
  install (Vue) {
    Vue.prototype.$Popup = Popup
  }
}



// WEBPACK FOOTER //
// ./src/globalComponent/popup/popup.js